import React from 'react';
import { Helmet } from 'react-helmet';
import T from 'prop-types';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { push as pushDefault } from 'connected-react-router';
import { ApiOutlined, CreditCardOutlined, UserOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';

import { PAGE_TITLE } from '../../constants/app';

import BillingSettings from '../../components/billingSettings';
import AccountSettings from '../../components/accountSettings';
import ApiSettings from '../../components/apiSettings';
import RequestBillingInfoData from '../../components/requestBillingInfoData';

const PAGES = ['account', 'billing', 'api'];
const { TabPane } = Tabs;

const Settings = ({ match, push }) => {
  const callback = (key) => {
    push(`/settings/${key}`);
  };

  const page = get(match.params, 'setting', PAGES[0]);
  const activeKey = PAGES.includes(page) ? page : PAGES[0];

  return (
    <>
      <Helmet>
        <title>{`Settings - ${PAGE_TITLE}`}</title>
      </Helmet>
      <RequestBillingInfoData />

      <Tabs activeKey={activeKey} animated={false} onChange={callback}>
        <TabPane
          key="account"
          tab={
            <span>
              <UserOutlined />
              Account
            </span>
          }
        >
          <AccountSettings />
        </TabPane>
        <TabPane
          key="api"
          tab={
            <span>
              <ApiOutlined />
              API
            </span>
          }
        >
          <ApiSettings />
        </TabPane>
        <TabPane
          key="billing"
          tab={
            <span>
              <CreditCardOutlined />
              Billing
            </span>
          }
        >
          <BillingSettings />
        </TabPane>
      </Tabs>
    </>
  );
};

const mapActionsToProps = {
  push: pushDefault,
};

Settings.propTypes = {
  push: T.func.isRequired,

  match: T.shape({
    params: T.shape({
      setting: T.string.isRequired,
    }),
  }).isRequired,
};

export default connect(null, mapActionsToProps)(Settings);
